import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/kaitori/shonin/:id',
    name: 'kaitoriShonin',
    component: () => import('../views/KaitoriShoninView.vue')
  },
  {
    path: '/kaitori/download/:id',
    name: 'kaitoriDownload',
    component: () => import('../views/KaitoriDownloadView.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
